import Vue from 'vue'
import { Button, Container, Header, Main, Aside, Menu, Submenu, MenuItem, Input, Form, FormItem, Select, Option, Row, Col, DatePicker, Table, TableColumn, Pagination, RadioGroup, Radio, Dialog, Message, CheckboxGroup , Checkbox, Upload, MessageBox, Cascader, Tree, Alert, Breadcrumb, BreadcrumbItem, Switch, Card, Tooltip, Popconfirm,Descriptions, DescriptionsItem, Image, Tag } from 'element-ui'

Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Dialog)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Cascader)
Vue.use(Tree)
Vue.use(Alert)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Switch)
Vue.use(Card)
Vue.use(Tooltip)
Vue.use(Popconfirm)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Image)
Vue.use(Tag)






Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm